import { render, staticRenderFns } from "./BusCard.vue?vue&type=template&id=0e24d8fc"
import script from "./BusCard.vue?vue&type=script&lang=js"
export * from "./BusCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports